import React from 'react'
import './portfolio.css'

const portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>
        My Recent Work
      </h5>
      <h2>
        Projects
      </h2>
      <div className="container portfolio__container">
        <article className="portfolio__items">
          <div className="portfolio__item-image"></div>
          <h3>CryptoTracker</h3>
          <p>Created a web app with Reactjs, Mongodb and Nodejs, which takes real time data
about different crypto currencies and provides the userthe latest trends and news
about the crypto they like. I worked extensively on axios,react states and redux to
make this app as smooth as possible. I deployed this app on AWS cloud and also used
load balancerto handle instance failures.</p>
          <div className="portfolio__item-cta">
          <a href="https://github.com/Sheryansh96/cryptoverse_data" className='btn' target="_blank">Github</a>
          </div>
        </article>
        <article className="portfolio__items">
          <div className="portfolio__item-image"></div>
          <h3>My Dear Watson</h3>
          <p>Created a Model using BERT and roBERTa, which are both Transformers, which was
used to classify sentences into entailment, contradictory and unrelated statements. I
worked on pretraining the transformer model using the training data and then added
a dense layerto classify the input into one of the 3 categories.                  
      </p>
      <div className="portfolio__item-cta">
          <a href="https://www.kaggle.com/code/shreyansh6996/tpu-robert" className='btn' target="_blank">Kaggle</a>
          </div>
        </article>
        <article className="portfolio__items">
          <div className="portfolio__item-image"></div>
          <h3>Deep Convolution Text to Speech</h3>
          <p>The aim of the project was to clone the voice of a person aftertraining it with 15
minutes of audio of that person. I used Machine Learning, Neural Networks,
tensorflow, python, managed sessions, CUDA extensively to create this project.</p>
          <a href="https://github.com/Sheryansh96/VoiceCloning_Dctts" className='btn' target="_blank">Github</a>
        </article>
        <article className="portfolio__items">
          <div className="portfolio__item-image"></div>
          <h3>Data Scientist job change prediction</h3>
          <p>Worked on balancing dataset using techniques like SMOTE, and Undersampling, and
then preprocess the data for prediction. Used different techniques for predicting like,
Linearregression, Decision Tree, Random Forest, SVM and ANN to predict the
probability for a Data scientist to change the job.</p>
          <a href="https://github.com/Sheryansh96/Data-Scientist-Job-Change-Prediction/blob/main/Job_Change_prediction.ipynb" className='btn' target="_blank">Github</a>
        </article>
        <article className="portfolio__items">
          <div className="portfolio__item-image"></div>
          <h3>Hotel Management System</h3>
          <p>Created a web app with Reactjs, Mongodb and Nodejs, which takes the details of the users and 
            add them to the database. The user is then able to book hotel in various parts of the world and the prices
            of the hotel are updated regularly based on the day of the week, time of the year and weekends.
          </p>
          <a href="https://github.com/Sheryansh96/BackupHotelBooking" className='btn' target="_blank">Github</a>
        </article>
      </div>
    </section>
  )
}

export default portfolio
